import React from 'react'

const BoardCard = ({children, className = ''}) => (
  <div className={`g-boardcard ${className}`}>
    {children}
  </div>
)

export default BoardCard
